import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

const mensagemDigito = 'Se não houver digito coloque X.'

export const schemaComCadastro = Yup.object().shape({
  nomeContato: Yup.string().required(mensagemPadrao),
  email: Yup.string()
    .email('Informe um e-mail válido')
    .required(mensagemPadrao),
  telefoneContato: Yup.string()
    .telefone()
    .required('Informe um telefone válido'),
  nomeFantasia: Yup.string().required(mensagemPadrao),
  cnpj: Yup.string().required(mensagemPadrao),
  repassInfo: Yup.array().of(
    Yup.object({
      repass: Yup.string().required('Informe um valor válido'),
      turmaId: Yup.string().required(mensagemPadrao)
    })
  ),
  merchantIdBraspag: Yup.string().required(mensagemPadrao),
  banco: Yup.string().required(mensagemPadrao),
  tipoConta: Yup.string().required(mensagemPadrao),
  agencia: Yup.string().required(mensagemPadrao),
  conta: Yup.string().required(mensagemPadrao),
  endereco: Yup.object().shape({
    pais: Yup.string().required(mensagemPadrao),
    cep: Yup.string()
      .required(mensagemPadrao)
      .nullable()
      .when('pais', {
        is: 'Brasil',
        then: field => field.required(mensagemPadrao)
      }),
    logradouro: Yup.string().required(mensagemPadrao),
    numero: Yup.string().required(mensagemPadrao),
    bairro: Yup.string().required(mensagemPadrao),
    cidade: Yup.string().required(mensagemPadrao),
    uf: Yup.string().required(mensagemPadrao)
  })
})

export const schemaSemCadastro = Yup.object().shape({
  nomeContato: Yup.string().required(mensagemPadrao),
  email: Yup.string()
    .email('Informe um e-mail válido')
    .required(mensagemPadrao),
  telefoneContato: Yup.string()
    .telefone()
    .required('Informe um telefone válido'),
  nomeFantasia: Yup.string().required(mensagemPadrao),
  razaoSocial: Yup.string().required(mensagemPadrao),
  cnpj: Yup.string().required(mensagemPadrao),
  repassInfo: Yup.array().of(
    Yup.object({
      repass: Yup.string().required('Informe um valor válido'),
      turmaId: Yup.string().required(mensagemPadrao)
    })
  ),
  banco: Yup.string().required(mensagemPadrao),
  tipoConta: Yup.string().required(mensagemPadrao),
  agencia: Yup.string().required(mensagemPadrao),
  digitoAgencia: Yup.string().required(mensagemPadrao),
  conta: Yup.string().required(mensagemPadrao),
  digitoConta: Yup.string().required(mensagemDigito),
  endereco: Yup.object().shape({
    pais: Yup.string().required(mensagemPadrao),
    cep: Yup.string()
      .nullable()
      .when('pais', {
        is: 'Brasil',
        then: field => field.required(mensagemPadrao)
      }),
    logradouro: Yup.string().required(mensagemPadrao),
    numero: Yup.string().required(mensagemPadrao),
    bairro: Yup.string().required(mensagemPadrao),
    cidade: Yup.string().required(mensagemPadrao),
    uf: Yup.string().required(mensagemPadrao)
  })
})
